import drugRevenueApiService from '../../services/api/DrugRevenueApiService';
import growthRateApiService from '../../services/api/GrowthRateApiService';
import viewCompetitorsApiService from '../../services/api/ViewCompetitorsApiService';
import viewDetailsApiService from '../../services/api/ViewDetailsApiService';
import chartApiService from '../../services/api/ChartApiService';
import authenticationApiService from '../../services/api/AuthenticationApiService';
import companyApiService from '../../services/api/CompanyApiService';
import categoryApiService from '../../services/api/CategoryApiService';
import settingApiService from '../../services/api/SettingApiService';
import subcategoryApiService from '../../services/api/SubcategoryApiService';
import classApiService from '../../services/api/ClassApiService';
import breakApartApiService from '../../services/api/BreakApartApiService';
import newDrugsApiService from '../../services/api/NewDrugsApiService';
import DrugBrandApiService from '../../services/api/DrugBrandApiService';
import TagApiService from "../../services/api/TagApiService";
import FinePrintApiService from "../../services/api/FinePrintApiService";
import ValidationError from "../../utils/ValidationError";

export default {
    namespaced: true,
    state: {
        services: {
            drugRevenue: drugRevenueApiService,
            growthRate: growthRateApiService,
            viewCompetitors: viewCompetitorsApiService,
            viewDetails: viewDetailsApiService,
            chart: chartApiService,
            authentication: authenticationApiService,
            company: companyApiService,
            category: categoryApiService,
            setting: settingApiService,
            subcategory: subcategoryApiService,
            class: classApiService,
            brand: DrugBrandApiService,
            tag: TagApiService,
            breakApart: breakApartApiService,
            newDrugs: newDrugsApiService,
            finePrint: FinePrintApiService,
        },
    },
    getters: {
        getService(state) {
            return service => state.services[service];
        },
    },
    mutations: {
        setToken(state, token) {
            Object.keys(state.services).forEach((service) => {
                state.services[service].setAuthorization(token);
            });
        },
    },
    actions: {
        async request(context, { service, type, data }) {
            try {
                const response = await context.getters.getService(service)[type](data);

                if (response && response.revenues && Object.keys(response.revenues).length >= 15) {
                    context.dispatch('message/show', {
                        type: 'warning',
                        text: 'The chart has more than 15 curves, please refine your filter to improve the readability of the chart data.',
                    }, { root: true });
                }

                return response;
            } catch (err) {
                err = JSON.parse(JSON.stringify(err));
                if (err && err.response && err.response.status === 401) {
                    context.dispatch('authentication/logout', null, { root: true });
                } else if (err && err.response && err.response.status === 422) {
                    throw new ValidationError(err.response.data);
                } else if (err && err.message) {
                    context.dispatch('message/show', { type: 'error', text: err.message }, { root: true });
                }

                return null;
            }
        },
    },
};
